import ky from "ky";
import { ICallbackRequest, ICallbackResponse } from "../models";
import { Log } from "./log.service";
import { AppConfigService as Config } from "./app.config.service";

export interface IOTPRequest {
  to: string;
  channel?: "SMS";
  locale?: string;
}

export interface IOTPResponse {
  id: string;
}

class SecurityServiceCtrl {
  private supportedLocales = [
    "af",
    "ar",
    "ca",
    "cs",
    "da",
    "de",
    "el",
    "en",
    "en-GB",
    "es",
    "fi",
    "fr",
    "he",
    "hi",
    "hr",
    "hu",
    "id",
    "it",
    "ja",
    "ko",
    "ms",
    "nb",
    "nl",
    "or",
    "zh-HK",
    "pl",
    "pr-BR",
    "pt",
    "ro",
    "ru",
    "sv",
    "th",
    "tl",
    "tr",
    "vi",
    "zh",
    "zh-CN",
  ];

  constructor() {}

  public async requestOTP(phone: string): Promise<string> {
    try {
      const locale = this.supportedLocales.includes(Config.language)
        ? Config.language
        : "en";
      const res: IOTPResponse = await ky
        .post(`${Config.auviousBaseUrl}/security/otp`, {
          json: {
            to: phone,
            channel: "SMS",
            customName: Config.organization,
            locale,
          },
        })
        .json();
      return res.id;
    } catch (ex) {
      Log.error(ex);
      throw ex;
    }
  }

  public async createCallback(
    OTP: string,
    verificationId: string,
    applicationId: string,
    callbackRequest: ICallbackRequest
  ): Promise<ICallbackResponse> {
    try {
      const res: any = await ky
        .post(`${Config.auviousBaseUrl}/security/genesys/callback`, {
          headers: {
            "X-OtpVerificationId": verificationId,
            "X-ApplicationId": applicationId,
            "X-OtpCode": OTP,
          },
          json: callbackRequest,
        })
        .json();
      return res;
    } catch (ex) {
      Log.error(ex);
      throw ex;
    }
  }

  public extractTicketFromUrl(ticketUrl: string): string {
    try {
      const url = new URL(ticketUrl);
      const ticket = url.pathname.split("t/")?.[1];
      return ticket;
    } catch (ex) {
      return ticketUrl;
    }
  }
}

export const SecurityService = new SecurityServiceCtrl();
